export default __webpack_public_path__ + "static/direccion-59191c7aca5efd8fe64216bc2afd78e4.png";